import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { ISectionNav } from 'interfaces/sections';
import { ItemsResponse } from 'types';

const name = 'sections';

type FetchSectionsParams = {
  organizationId: string;
};
export const fetchSections = createAsyncThunk(
  `${name}/fetch`,
  async ({ organizationId }: FetchSectionsParams, { dispatch }) => {
    try {
      const { data } = await axios.get<ItemsResponse<ISectionNav>>(
        `/api/questionnaire/v1/organizations/${organizationId}/sectionOrders`
      );
      return data;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  sections: ISectionNav[];
  total: number;
};

const initialState: State = {
  isFetching: false,
  sections: [],
  total: 0,
  error: null
};

const sections = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchSections.pending, isFetching)
      .addCase(fetchSections.fulfilled, (state, action) => {
        state.sections = action.payload.items;
        state.total = action.payload.totalCount;
        state.isFetching = false;
      })
      .addCase(fetchSections.rejected, error);
  }
});

export const { reducer: sectionsReducer } = sections;
